import { authPost } from './authMiddleware';

export const postPeopleList = (data) => {
    return authPost('/api/People', data);
}